import React, { useEffect, useState } from "react";
import "./style.scss";
import { Pagination, Table } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetAllBatchesForReview } from "../../../hooks/useReview";

const BatchQuoteDetails = () => {
  const [batchList, setBatchList] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [pageNum, setPageNum] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const onPageChange = (page, size) => {
    if (page !== pageNum) {
      setPageNum(page);
    } else {
      setPageSize(size);
      setPageNum(1);
    }
  };

  const columns = [
    {
      title: "Batch Name",
      key: "name",
      align: "center",
      dataIndex: "name",
      render: (_, record, index) => {
        return (
          <div>
            {`${record?.name} ${
              record?.lastName != null ? record?.lastName : ""
            }` || ""}
          </div>
        );
      },
    },
    // {
    //   title: "No. of Images",
    //   key: "NoOfImages",
    //   align: "center",
    //   dataIndex: "NoOfImages",
    //   render: (_, record, index) => {
    //     return <div>{record?.numberOfInputImages || "-"}</div>;
    //   },
    // },
    {
      title: "Pending Skus",
      key: "pendingSkus",
      align: "center",
      dataIndex: "totalPendingSkuOnSegregation",
      render: (_, record, index) => {
        return <div>{record?.totalPendingSkuOnSegregation || "-"}</div>;
      },
    },
    // {
    //   title: "Status",
    //   key: "status",
    //   align: "center",
    //   dataIndex: "status",
    //   render: (_, record) => {
    //     return <div>{record?.displayStage}</div>;
    //   },
    // },
    {
      title: "Action",
      key: "action",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <div>
            <Link to={`/review-sku-list/${record?._id}`}>Start</Link>
          </div>
        );
      },
    },
  ];
  const clientColumns = [
    {
      title: "S.No.",
      key: "s.no.",
      align: "center",
      dataIndex: "index",
      render: (_, record, index) => {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: "Name",
      key: "clientName",
      align: "center",
      dataIndex: "clientName",
      render: (_, record, index) => {
        return (
          <div>
            {record?.users[0]?.name} {record?.users[0]?.lastName}
          </div>
        );
      },
    },
    {
      title: "Email",
      key: "clientEmail",
      align: "center",
      dataIndex: "clientEmail",
      render: (_, record) => {
        return <div>{record?.users[0]?.email?.emailId}</div>;
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <div>
            <Link to={`/review-sku-list/${record?._id}`}>Start</Link>
          </div>
        );
      },
    },
  ];
  const onSuccessGetAllBatches = (res) => {
    console.log(res);
    if (res.status === 200) {
      setBatchList(res.data.data);
      setTotalCount(res?.data?.totalCount);
    }
  };
  const onErrorGetAllBatches = (err) => {
    console.log(err);
  };
  const { data: getAllBatches } = useGetAllBatchesForReview(
    "batch_list",
    pageNum,
    pageSize,
    onSuccessGetAllBatches,
    onErrorGetAllBatches
  );

  return (
    <div className="review_batch_list">
      <div className="review_batch_list_content">
        <div className="list_wrapper">
          <Table
            columns={columns}
            dataSource={batchList}
            scroll={{
              // x: 2100,
              y: `100%`,
            }}
            className="main_table"
            pagination={false}
            // onRow={(record, rowIndex) => {
            //   return {
            //     onClick: () => {
            //       navigate(`/review-sku-list/${record._id}`);
            //     },
            //   };
            // }}
          />
        </div>
        <div className="pagination_wrapper">
          <Pagination
            total={totalCount}
            // showTotal={false}
            // defaultPageSize={10}
            current={pageNum}
            pageSize={pageSize}
            onChange={onPageChange}
          />
        </div>
      </div>
    </div>
  );
};
export default BatchQuoteDetails;
